import { render, staticRenderFns } from "./Matching.vue?vue&type=template&id=2a4708eb&scoped=true&"
import script from "./Matching.vue?vue&type=script&lang=js&"
export * from "./Matching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4708eb",
  null
  
)

export default component.exports